<template>
  <button
    type="button"
    :class="[
      `btn btn-${
        pinned && color === 'secondary'
          ? 'outline-secondary'
          : (pinned && color === 'outline-secondary' ? 'primary' : color)
      }`
    ]"
    @click="toggle"
  >
    <icon
      v-if="icon"
      src="@/assets/icons/pin.svg"
    />
    <template v-else>
      {{ $t(pinned ? 'pinboardStatus.pinned' : 'pinboardStatus.pin') }}
    </template>
  </button>
</template>

<script>
import pinnable from '@/mixins/pinnable'

export default {
  name: 'PinboardStatusButton',
  mixins: [pinnable],
  props: {
    color: {
      type: String,
      default: 'outline-secondary'
    },
    icon: {
      type: Boolean,
      default: false
    }
  }
}
</script>
